import React from 'react';

import { Row, Col, Button } from 'antd';

import { useGlobalModal } from 'hooks';

const AddProductToAPLModalFooter = (props) => {
  const { onOk, onCancel, loading, disabled } = props;

  const { MODAL_NAMES, openModal } = useGlobalModal();

  const onClickAddToNewBtn = () => {
    openModal(MODAL_NAMES.ADD_TO_NEW_APL);
  };

  return (
    <Row>
      <Col>
        <Button type='primary' onClick={onClickAddToNewBtn}>
          Add To New APL
        </Button>
      </Col>
      <Col flex={1}></Col>
      <Col>
        <Button onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          type='primary'
          loading={loading}
          disabled={disabled}
          onClick={onOk}
        >
          OK
        </Button>
      </Col>
    </Row>
  );
};

export default AddProductToAPLModalFooter;
